import React from 'react';
import { motion } from 'framer-motion';
import { Testimonial } from '../types';

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Dr. Sarah Chen",
    role: "Holistic Medicine Practitioner",
    content: "Aiden's knowledge of ancient healing practices combined with modern science has revolutionized my approach to patient care. The results speak for themselves.",
    image: "/images/testimonials/sarah-chen.jpg"
  },
  {
    id: 2,
    name: "James Rodriguez",
    role: "Hedge Fund Manager",
    content: "The financial strategies I learned from ForeverHealing have helped me achieve returns I never thought possible. This isn't just another investment course - it's a complete paradigm shift.",
    image: "/images/testimonials/james-rodriguez.jpg"
  },
  {
    id: 3,
    name: "Emily Thompson",
    role: "Wellness Influencer",
    content: "After implementing Aiden's teachings, my audience grew exponentially, and more importantly, the value I provide to them has deepened significantly.",
    image: "/images/testimonials/emily-thompson.jpg"
  }
];

export const Testimonials = () => {
  return (
    <section className="py-24 bg-gradient-to-b from-black to-purple-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl font-bold text-center text-white mb-16">
            Transformational Results
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {testimonials.map((testimonial) => (
              <motion.div
                key={testimonial.id}
                whileHover={{ scale: 1.05 }}
                className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 text-white"
              >
                <div className="flex items-center mb-6">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full mr-4"
                  />
                  <div>
                    <h3 className="font-semibold text-lg">{testimonial.name}</h3>
                    <p className="text-purple-300">{testimonial.role}</p>
                  </div>
                </div>
                <p className="text-gray-300 italic">{testimonial.content}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};